import { useState } from "react";
import { initials } from "@/lib/format";

// Avatar fallback hierarchy: uploaded/provided src -> initials.
export function Avatar({ src, name = "", size = 36, color = "#00A85A", className = "" }) {
  const [err, setErr] = useState(false);
  const show = src && !err;
  return (
    <div
      className={`flex items-center justify-center overflow-hidden rounded-full font-bold text-white shrink-0 ${className}`}
      style={{ width: size, height: size, background: color, fontSize: size * 0.36 }}
      data-testid="avatar"
    >
      {show ? <img src={src} alt={name} onError={() => setErr(true)} className="h-full w-full object-cover" /> : initials(name)}
    </div>
  );
}
